/**
 * The report statuses a session row can carry once submitted (tblStatus ids). Drives the Attendance /
 * MILPR status filter; ids match TutorPortalAPI's SessionReportStatus and ClientReportFilter.StatusIds.
 * Labels match the SessionStatusPillComponent keys so the same pill renders both the filter and the rows.
 */
export const SESSION_REPORT_STATUSES: { id: number; name: string }[] = [
    { id: 2, name: 'Submitted' },
    { id: 3, name: 'Approved' },
    { id: 4, name: 'Rejected' },
];

export const ALL_SESSION_REPORT_STATUS_IDS: number[] = SESSION_REPORT_STATUSES.map(status => status.id);
